/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Zns_Send_UnknownInputs */

const vi_error_zns_send_unknown = /** @type {(inputs: Error_Zns_Send_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất kết nối khi chờ Zalo — tin có thể đã gửi. Xem tab Nhật ký gửi trước khi gửi lại.`)
};

/**

* @param {Error_Zns_Send_UnknownInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_zns_send_unknown = /** @type {((inputs?: Error_Zns_Send_UnknownInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Zns_Send_UnknownInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_zns_send_unknown(inputs)
});